import { 
  ChangePasswordModel, 
} from './change-password.model';

import { 
  BaseClass,
  dropProps,
} from 'src/api/models/Base/base.class';

import { InputModel } from 'src/api/models/Form/InputField/input.model';

import { InputClass } from 'src/api/models/Form/InputField/input.class';

import { changePasswordFormData } from './change-password.data';

export class ChangePasswordClass extends BaseClass<ChangePasswordModel> implements ChangePasswordModel {
  get oldPassword(): InputModel {
    return dropProps(this.props.oldPassword, new InputClass(this.props.oldPassword)); 
  }
  
  get newPassword(): InputModel {
    return dropProps(this.props.newPassword, new InputClass(this.props.newPassword)); 
  }

  get password(): InputModel {
    return dropProps(this.props.password, new InputClass(this.props.password)); 
  }
}

export const ChangePasswordFormValues = () => changePasswordFormData && dropProps(
  changePasswordFormData(), 
  new ChangePasswordClass(changePasswordFormData())
);
